<template>
  <v-form ref="registrationForm">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          class="register-form-field"
          label="First Name *"
          :rules="[rules.required]"
          maxlength="50"
          :value="value.firstName"
          @input="$emit('input', {field: 'firstName', value: $event})"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          class="register-form-field"
          label="Last Name *"
          :rules="[rules.required]"
          maxlength="50"
          :value="value.lastName"
          @input="$emit('input', {field: 'lastName', value: $event})"
          hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          class="register-form-field"
          label="Email *"
          :rules="[rules.required, rules.validEmail]"
          maxlength="50"
          :value="value.email"
          @input="$emit('input', {field: 'email', value: $event})"
          hide-details="auto"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          class="register-form-field"
          label="Company *"
          maxlength="50"
          :rules="[rules.required]"
          :value="value.company"
          @input="$emit('input', {field: 'company', value: $event})"
          hide-details="auto"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          class="register-form-field"
          label="Country *"
          :rules="[rules.required]"
          :items="countries"
          :value="value.country"
          @input="$emit('input', {field: 'country', value: $event})"
          hide-details="auto"
          clearable
        >
        </v-select>
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          class="register-form-field"
          label="Industry"
          :items="industries"
          :value="value.industry"
          @input="$emit('input', {field: 'industry', value: $event})"
          hide-details="auto"
          clearable
        >
        </v-select>
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          class="register-form-field"
          label="Role"
          :items="roles"
          :value="value.roleName"
          @input="$emit('input', {field: 'roleName', value: $event})"
          hide-details="auto"
          clearable
        >
        </v-select>
      </v-col>

      <v-col cols="12" md="4">
        <v-text-field
          class="register-form-field"
          label="Job Title"
          maxlength="50"
          :value="value.title"
          @input="$emit('input', {field: 'title', value: $event})"
          hide-details="auto"
        >
        </v-text-field>
      </v-col>

      <v-col cols="12">
        <v-checkbox hide-details="auto" @change="$emit('input', {field: 'marketingOptIn', value: $event})" :value="value.marketingOptIn" label="I consent to receive electronic marketing communications on relevant products, services, publications, and events."></v-checkbox>
        <v-checkbox hide-details="auto" @change="$emit('input', {field: 'readyToSpeakWithSales', value: $event})" :value="value.readyToSpeakWithSales" label="I'm ready to speak with a solution specialist."></v-checkbox>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { Rules } from '@itus/ui.common'

export default {
  name: 'RegistrationForm',
  props: {
    value: {
      type: Object,
      description: 'Reistered user object',
      default: function() {
        return {
          firstName: null,
          lastName: null,
          email: null,
          title: null,
          roleName: null,
          company: null,
          industry: null
        }
      }
    }
  },
  data() {
    return {
      rules: Rules,
      roles: [
        'Business Strategy',
        'Construction',
        'Construction Management',
        'Contract Management',
        'Corporate Operations',
        'Education/Training',
        'Engineering',
        'Enterprise Performance',
        'Finance',
        'HVAC',
        'Instrumentation/Electrical',
        'IT/Systems Administration',
        'Mechanical',
        'Pipe Stress Analysis',
        'Piping and Plant',
        'Plant Maintenance and Operations',
        'Portfolio Management',
        'Pressure Vessel/Exchanger Analysis',
        'Procurement',
        'Project Engineering',
        'Sales/Marketing',
        'Structural'
      ],
      industries: [
        'Aerospace',
        'Agriculture',
        'Automotive',
        'Chemical',
        'Communications',
        'Construction',
        'Education/Faculty',
        'Financial',
        'Food & Beverage',
        'Manufacturing',
        'Marine',
        'Media & Entertainment',
        'Medical',
        'Mining',
        'Oil & Gas',
        'Other',
        'Power & Energy Production',
        'Public Sector/Government',
        'Pulp and Paper',
        'Retail',
        'Safety & Security',
        'Surveying & Engineering',
        'Transportation',
        'Utilities'
      ],
      countries: [
        'United States',
        'Canada',
        'Afghanistan',
        'Aland Islands',
        'Albania',
        'Algeria',
        'American Samoa',
        'Andorra',
        'Angola',
        'Anguilla',
        'Antarctica',
        'Antigua and Barbuda',
        'Argentina',
        'Armenia',
        'Aruba',
        'Australia',
        'Austria',
        'Azerbaijan',
        'Bahamas',
        'Bahrain',
        'Bangladesh',
        'Barbados',
        'Belarus',
        'Belgium',
        'Belize',
        'Benin',
        'Bermuda',
        'Bhutan',
        'Bolivia',
        'Bonaire',
        'Bosnia and Herzegovina',
        'Botswana',
        'Bouvet Island',
        'Brazil',
        'British Indian Ocean Territory',
        'British Virgin Islands',
        'Brunei Darussalam',
        'Bulgaria',
        'Burkina Faso',
        'Burundi',
        'Cambodia',
        'Cameroon',
        'Cape Verde',
        'Cayman Islands',
        'Central African Republic',
        'Chad',
        'Chile',
        'China',
        'Christmas Island',
        'Cocos (Keeling) Islands',
        'Colombia',
        'Comoros',
        'Congo',
        'Congo, the Democratic Republic of the',
        'Cook Islands',
        'Costa Rica',
        'Croatia',
        'Curacao',
        'Cyprus',
        'Czech Republic',
        'Cote d\'Ivoire',
        'Democratic Republic of the Congo',
        'Denmark',
        'Djibouti',
        'Dominica',
        'Dominican Republic',
        'East Timor',
        'Ecuador',
        'Egypt',
        'El Salvador',
        'Equatorial Guinea',
        'Eritrea',
        'Estonia',
        'Ethiopia',
        'Falkland Islands (Malvinas)',
        'Falkland Islands',
        'Faroe Islands',
        'Fiji',
        'Finland',
        'France',
        'French Guiana',
        'French Polynesia',
        'French Southern Territories',
        'Gabon',
        'Gambia',
        'Georgia',
        'Germany',
        'Ghana',
        'Gibraltar',
        'Greece',
        'Greenland',
        'Grenada',
        'Guadeloupe',
        'Guam',
        'Guatemala',
        'Guinea',
        'Guinea-Bissau',
        'Guyana',
        'Haiti',
        'Heard and McDonald Islands',
        'Honduras',
        'Hong Kong',
        'Hungary',
        'Iceland',
        'India',
        'Indonesia',
        'Iraq',
        'Ireland',
        'Israel',
        'Italy',
        'Jamaica',
        'Japan',
        'Jordan',
        'Kazakhstan',
        'Kenya',
        'Kiribati',
        'Kosovo',
        'Kuwait',
        'Kyrgyzstan',
        'Laos',
        'Latvia',
        'Lebanon',
        'Lesotho',
        'Liberia',
        'Libya',
        'Liechtenstein',
        'Lithuania',
        'Luxembourg',
        'Macau',
        'Macao S.A.R., China',
        'Macedonia',
        'Madagascar',
        'Malawi',
        'Malaysia',
        'Maldives',
        'Mali',
        'Malta',
        'Marshall Islands',
        'Martinique French',
        'Martinique',
        'Mauritania',
        'Mauritius',
        'Mayotte',
        'Mexico',
        'Micronesia',
        'Moldova',
        'Monaco',
        'Mongolia',
        'Montenegro',
        'Montserrat',
        'Morocco',
        'Mozambique',
        'Myanmar',
        'Namibia',
        'Nauru',
        'Nepal',
        'Netherlands',
        'Netherlands Antilles',
        'New Caledonia',
        'New Zealand',
        'Nicaragua',
        'Niger',
        'Nigeria',
        'Niue',
        'Norfolk Island',
        'Northern Mariana Islands',
        'Norway',
        'Oman',
        'Pakistan',
        'Palau',
        'Palestinian Territory',
        'Panama',
        'Papua New Guinea',
        'Paraguay',
        'Peru',
        'Philippines',
        'Pitcairn',
        'Poland',
        'Portugal',
        'Puerto Rico',
        'Qatar',
        'Reunion',
        'Romania',
        'Russian Federation',
        'Rwanda',
        'S. Georgia & S. Sandwich Isls.',
        'Saint Barthelemy',
        'Saint Helena',
        'Saint Kitts & Nevis',
        'Saint Lucia',
        'Saint Martin (French part)',
        'Saint Pierre and Miquelon',
        'Saint Vincent & Grenadines',
        'Samoa',
        'San Marino',
        'Sao Tome and Principe',
        'Saudi Arabia',
        'Senegal',
        'Serbia',
        'Seychelles',
        'Sierra Leone',
        'Singapore',
        'Sint Maarten (Dutch part)',
        'Slovakia',
        'Slovenia',
        'Solomon Islands',
        'Somalia',
        'South Africa',
        'South Korea',
        'South Sudan',
        'Spain',
        'Sri Lanka',
        'Sudan',
        'Suriname',
        'Svalbard and Jan Mayen Islands',
        'Swaziland',
        'Sweden',
        'Switzerland',
        'Taiwan, Province of China',
        'Tajikistan',
        'Tanzania',
        'Thailand',
        'Timor-Leste',
        'Togo',
        'Tokelau',
        'Tonga',
        'Trinidad and Tobago',
        'Tunisia',
        'Turkey',
        'Turkmenistan',
        'Turks and Caicos Islands',
        'Tuvalu',
        'U.S. Virgin Islands',
        'Uganda',
        'Ukraine',
        'United Arab Emirates',
        'United Kingdom',
        'United States Minor Outlying Islands',
        'Uruguay',
        'USA Minor Outlying Islands',
        'Uzbekistan',
        'Vanuatu',
        'Vatican',
        'Venezuela',
        'Vietnam',
        'Virgin Islands, British',
        'Virgin Islands, US',
        'Wallis and Futuna Islands',
        'Western Sahara',
        'Yemen',
        'Zambia',
        'Zimbabwe'
      ]
    }
  },
  methods: {
    validate() {
      return this.$refs.registrationForm.validate()
    }
  }
}
</script>
<style lang="scss" scoped>
.register-form-field {
  width: 100%;
}
</style>